module.exports = __webpack_public_path__ + "img/1w.837d6086.svg";